export default __webpack_public_path__ + "static/media/outside_bets.df6fd868.mp3";